import { render, staticRenderFns } from "./ProjectGridCard.vue?vue&type=template&id=13de3820"
import script from "./ProjectGridCard.vue?vue&type=script&lang=js"
export * from "./ProjectGridCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectGridCard.vue?vue&type=style&index=0&id=13de3820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports